import React from 'react';
import './AttachmentError.scss';
import BaseComponent from '../../../../../baseClasses/BaseComponent';
import warningIcon from '../../../../../assets/images/warning-blue.svg';
import LocationsIconSolid from '../../../../../components/Iconoclast/LocationsIconSolid/index';
import closeoutsService from '../../../../../services/closeoutsService';
import dataModel from '../../../../../models/DataModel';

class AttachmentError extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  handleClick() {
    const messageText = 'A Closeout Package will be generated. When your Closeout Package is complete, you will recieve a notification and be able to access it from the Plan of Record.';
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      captionText: 'ATTENTION',
      type: 'info',
      message: <span>{messageText} <LocationsIconSolid/> </span>,
      cancelButtonText: this.textMap.cancel,
      okButtonText: 'OK',
      okButtonColor: 'green',
      width: 320,
      height: 200,
      handleOwnerOk: () => {
        closeoutsService.updateCloseout(this.props.attachment, true)
          .catch(error => {
            dataModel.displayHTTPError('Error regenerating the closeout', error, false);
          });
      },
    });
  }

  render() {
    return (
      <div className="attachment-error">
        <div className="display-container">
          <div className="warning-icon">
            <img src={warningIcon} alt="Warning" />
          </div>
          <div className="warning-text">
            There was an error generating your closeout for this project.
          </div>
          <div className="retry-text" onClick={this.handleClick}>
            Please try again.
          </div>
        </div>
      </div>
    );
  }
}

export default AttachmentError;



// WEBPACK FOOTER //
// ./src/containers/PORContainer/PORProjectDocuments/AttachmentsTable/AttachmentError/index.js